import { ReactComponent as BkgComponent } from '../assets/bkg-cas.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-cyklus-1": "/cas/cycle/1",
  "link-cyklus-2": "/cas/cycle/2",
  "link-cyklus-3": "/cas/cycle/3",
  "link-misc": "/cas/misc",
  "link-back": "/main",
};

function Cas() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} />;
}

export default Cas;
